
/* LA PINK - Product card cart quantity controls */
(() => {
  if (window.laPinkCartQuantityLoaded) return;
  window.laPinkCartQuantityLoaded = true;

  const selector = '.lapink-cart-control';
  const root = window.Shopify?.routes?.root || '/';
  let busy = false;

  async function cartRequest(path, options) {
    const response = await fetch(root + path, {
      credentials: 'same-origin',
      ...options
    });

    if (!response.ok) {
      let message = 'Unable to update cart.';
      try {
        const error = await response.json();
        message = error.description || error.message || message;
      } catch (_) {}
      throw new Error(message);
    }

    return response.json();
  }

  function updateControls(cart) {
    const quantities = new Map();

    for (const item of cart.items) {
      const id = String(item.variant_id);
      quantities.set(
        id,
        (quantities.get(id) || 0) + item.quantity
      );
    }

    document.querySelectorAll(selector).forEach(control => {
      const id = control.dataset.variantId;
      const quantity = quantities.get(id) || 0;

      const add = control.querySelector('.lapink-add-button');
      const stepper = control.querySelector('.lapink-qty-selector');
      const value = control.querySelector('.lapink-qty-value');

      add.hidden = quantity > 0;
      stepper.hidden = quantity === 0;
      value.querySelector('.lapink-qty-number').textContent = quantity;

      control.querySelectorAll('button').forEach(button => {
        button.disabled = busy;
      });
    });
  }

  
  
  // Synchronize header basket badge with Shopify cart
  function updateHeaderCartCount(cart) {
    const count = cart.item_count;
    const cartIcon = document.querySelector('#cart-icon-bubble');

    if (!cartIcon) return;

    let badge = cartIcon.querySelector('.cart-count-bubble');

    // Remove badge when cart is empty
    if (count === 0) {
      if (badge) badge.remove();
      return;
    }

    // Create badge if it does not exist
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart-count-bubble';
      cartIcon.appendChild(badge);
    }

    // Match Be Yours theme behaviour for 100+ items
    badge.classList.toggle('cart-count-bubble--dot', count >= 100);

    badge.innerHTML = '';

    if (count < 100) {
      const number = document.createElement('span');
      number.setAttribute('aria-hidden', 'true');
      number.textContent = count;
      badge.appendChild(number);
    }

    const accessibleCount = document.createElement('span');
    accessibleCount.className = 'visually-hidden';
    accessibleCount.textContent = count + ' items in cart';
    badge.appendChild(accessibleCount);
  }




  async function getCart() {
    return cartRequest('cart.js');
  }

  async function refresh() {
  const cart = await getCart();
  updateControls(cart);
  updateHeaderCartCount(cart);
  return cart;
}

  async function changeQuantity(variantId, action) {
    const cart = await getCart();
    const items = cart.items.filter(
      item => String(item.variant_id) === String(variantId)
    );

    if (action === 'add') {
      await cartRequest('cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }]
        })
      });
      return;
    }

    // Decrease the last matching cart line by one.
    const item = items[items.length - 1];
    if (!item) return;

    await cartRequest('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: item.key,
        quantity: Math.max(0, item.quantity - 1)
      })
    });
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest(
      '.lapink-add-button, .lapink-qty-plus, .lapink-qty-minus'
    );

    if (!button || busy) return;

    const control = button.closest(selector);
    if (!control) return;

    event.preventDefault();
    event.stopPropagation();

    const variantId = control.dataset.variantId;
    const isMinus = button.classList.contains('lapink-qty-minus');

    
busy = true;


// Show spinner when + or - is clicked
const isQuantityClick =
  button.classList.contains('lapink-qty-plus') ||
  button.classList.contains('lapink-qty-minus');

const qtyNumber = control.querySelector('.lapink-qty-number');
const qtySpinner = control.querySelector('.lapink-qty-spinner');

if (isQuantityClick) {
  qtyNumber.hidden = true;
  qtySpinner.hidden = false;
}


// Show loading spinner on ADD TO CART
        const addButton = control.querySelector('.lapink-add-button');
        const addText = addButton.querySelector('.lapink-add-text');
        const addLoading = addButton.querySelector('.lapink-add-loading');

        if (button.classList.contains('lapink-add-button')) {
            addText.hidden = true;
            addLoading.hidden = false;
        }

        document.querySelectorAll(selector + ' button').forEach(b => {
        b.disabled = true;
    });


    try {
      await changeQuantity(variantId, isMinus ? 'minus' : 'add');
      const cart = await getCart();

      busy = false;
      updateControls(cart);
      updateHeaderCartCount(cart);

      document.dispatchEvent(new CustomEvent(
        'lapink:cart-updated',
        { detail: { cart } }
      ));
    
} catch (error) {
  busy = false;
  alert(error.message);
  await refresh().catch(console.error);


} finally {
  busy = false;

  addText.hidden = false;
  addLoading.hidden = true;

  qtyNumber.hidden = false;
  qtySpinner.hidden = true;

  document.querySelectorAll(selector + ' button').forEach(b => {
    b.disabled = false;
  });
}


  });

  document.addEventListener('DOMContentLoaded', () => {
    refresh().catch(console.error);
  });

  // Refresh when returning to this page.
  window.addEventListener('pageshow', () => {
    refresh().catch(console.error);
  });


  // LA PINK - Sync product cards with Razorpay Magic Checkout
  // Detect cart changes made outside our quantity controls.

  let lastCartSignature = null;
  let syncInProgress = false;

  async function syncExternalCart() {
    if (busy || syncInProgress || document.hidden) return;

    syncInProgress = true;

    try {
      const cart = await getCart();

      const signature = JSON.stringify(
        cart.items.map(item => [item.key, item.quantity])
      );

      if (signature !== lastCartSignature) {
        lastCartSignature = signature;
        updateControls(cart);
        updateHeaderCartCount(cart);
      }
    } catch (error) {
      console.warn('La Pink cart sync:', error);
    } finally {
      syncInProgress = false;
    }
  }

  // Check for external cart changes every 5 seconds.
  setInterval(syncExternalCart, 5000);

  // Refresh immediately when returning to the browser tab.
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncExternalCart();
  });

  // Available for later integration with other cart components.
  window.laPinkRefreshCartQuantity = refresh;
})();
